
import PopUpForm from "@/components/main/forms/PopUpForm";

export default {
  name: "Modal",
  mixins: [],
  components: {PopUpForm},
  data() {
    return {}
  },
  computed: {},
  mounted() {
    this.lockScroll();
  },
  beforeDestroy() {
    this.unlockScroll();
  },
  deactivated() {
    this.unlockScroll();
  },
  methods: {
    isMobileDevice() {
      return process.client && (window.innerWidth <= 768 || 'ontouchstart' in window || navigator.maxTouchPoints > 0);
    },
    lockScroll() {
      const count = +document.body.dataset.modalCount || 0;
      document.body.dataset.modalCount = count + 1;
      
      if (this.isMobileDevice()) {
        const scrollY = window.scrollY || window.pageYOffset;
        document.body.dataset.scrollY = scrollY;
        document.body.style.position = 'fixed';
        document.body.style.top = `-${scrollY}px`;
        document.body.style.width = '100%';
        document.body.style.overflow = 'hidden';
        document.body.style.touchAction = 'none';
      } else {
        document.body.style.overflow = 'hidden';
      }
    },
    unlockScroll() {
      const count = (+document.body.dataset.modalCount || 1) - 1;
      if (count <= 0) {
        if (this.isMobileDevice()) {
          const scrollY = document.body.dataset.scrollY || 0;
          document.body.style.position = '';
          document.body.style.top = '';
          document.body.style.width = '';
          document.body.style.overflow = '';
          document.body.style.touchAction = '';
          delete document.body.dataset.scrollY;
          window.scrollTo(0, parseInt(scrollY || '0', 10));
        } else {
          document.body.style.overflow = '';
        }
        delete document.body.dataset.modalCount;
      } else {
        document.body.dataset.modalCount = count;
      }
    },
  }
}
